import React from 'react';

import { ContactPage } from '@edx/pages/contact';

const bgImage = {
  small: '/img/contact/contact_header-s.jpg',
  medium: '/img/contact/contact_header-m.jpg',
  large: '/img/contact/contact_header-l.jpg',
};

const ContactoPage: React.FC = () => <ContactPage bgImage={bgImage} />;

export default ContactoPage;
